import { useEffect, useState } from "react";
import { Card, FormGroup, FormLabel } from "react-bootstrap";
import { SimpleFormField } from "../components/SimpleFormField";
import { listMemberForId, useChainedState } from "../util/utils";
import { ObjectSelector } from "../components/ObjectSelector";

export function InspectionJobForm(props) {
	// Properties
	let { inspection, jobs, onJobChange } = props;
	
	// State
	let [jobId, setJobId] = useChainedState(inspection.jobId, (newJobId) => {
		let job = listMemberForId(jobs, newJobId);
		inspection.job = job;
		
		onJobChange?.();
	});
	
	const labelToInspectionProp = {
		"Customer": "companyName",
		"Location": "location",
		"Contact": "contactName",
		"Phone": "contactPhone",
		"Email": "contactEmail",
		"Address": "contactAddress",
	};
	const keys = Object.keys(labelToInspectionProp);
	const [value, setValue] = useState(keys.reduce((accum, key) => { return {...accum, [key]: inspection[labelToInspectionProp[key]]}}, {}) );
	let color = "#007041"
	
	useEffect(() => {
		let job = listMemberForId(jobs, jobId);
		if(job){
			// Fill in blank values from job
			setValue( Object.keys(value).reduce( (accum, key) => {return {...accum, [key]: (value[key] || job[labelToInspectionProp[key]]) }}, {} ) );
		}
		// This line appears to be useless
		inspection.job = job;
	}, [jobId]);
	
	const getJobValueFields = function() {		
		return (
			keys.map((label) => <SimpleFormField key={label} className="mt-3" color={color} label={label} value={value[label]} onChange={ (e) => {setValue({...value, [label]: e.target.value})} } />)
		);
	}
		
	if(inspection){
		inspection.companyName = value["Customer"];
		inspection.location = value["Location"];
		inspection.contactName = value["Contact"];
		inspection.contactPhone = value["Phone"];
		inspection.contactEmail = value["Email"];
		inspection.contactAddress = value["Address"];
	}
		
	return <Card className="mt-3">
		<Card.Header>
			<Card.Title >Job Information</Card.Title>
		</Card.Header>
		<Card.Body>
			<FormGroup>
				<FormLabel style={{color:"#007041"}}>Job</FormLabel>
				<ObjectSelector options={jobs} valueAttribute="id" labelAttribute="name" onValueChange={setJobId} defaultValue={jobId}></ObjectSelector>
			</FormGroup>
			{getJobValueFields()}
			{inspection.rentalMode &&
				<FormGroup className="mt-3">
					<FormLabel>Mode</FormLabel>
					<span className="form-control disabled bg-light"><i>Rental</i></span>
				</FormGroup>
			}
		</Card.Body>
	</Card>;
}